export default __webpack_public_path__ + "static/media/bci-8.6ca73b02.svg";